import { render, staticRenderFns } from "./QuizTeacherEditQuestion.vue?vue&type=template&id=7351fadf&"
import script from "./QuizTeacherEditQuestion.vue?vue&type=script&lang=js&"
export * from "./QuizTeacherEditQuestion.vue?vue&type=script&lang=js&"
import style0 from "./QuizTeacherEditQuestion.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports